import { extractStringValueSet } from "./extract-properties";

export default class ExternalReferenceLabTestVersions {
    /* eslint-disable camelcase */
    static readonly v1_0_0: string = 'v1.0.0';
    static readonly v2_0_0: string = 'v2.0.0';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
